/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

'use strict';

const OwnerReviewResponse = {

	$domOwnerReviewResponseRadio: 'input[name="sugg-feedback"]',
	isFetching: false,

	/**
	 * @description Initialize
	 */
	init: function() {
		this.bindEvents();
	},

	bindEvents: function() {
		$(document).on('change', this.$domOwnerReviewResponseRadio, this.ownerReviewResponseChange);
	},

	/**
	 * @description Handles owner review response
	 */
	ownerReviewResponseChange: async function(event) {
		event.preventDefault();

		if (this.isFetching) {
			return;
		}

		this.isFetching = true;

		const $radio = $(this);
		const reviewId = $radio.data('review-id');
		const ownerResponse = $radio.val();

		if (!reviewId || ownerResponse === undefined) {
			console.error('Review ID or owner response is missing.');
			this.isFetching = false;
			return;
		}

		try {
			const response = await fetch(`${window.origin}/wp-json/office-pulse-api/v1/review/owner-response`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${window.apiSettings.token}`,
				},
				body: JSON.stringify({
					review_id: reviewId,
					owner_response: parseInt(ownerResponse, 10),
				}),
			});

			const result = await response.json();

			if (!response.ok) {
				console.error(result.error || 'Something went wrong');
				alert(result.error || 'Failed to update owner response.');
				this.isFetching = false;
				return;
			}

			console.log(result.message);

		} catch (error) {
			console.error('Error:', error);
		} finally {
			this.isFetching = false;
		}
	},
};

export default OwnerReviewResponse;
